const HP_Constants = Object.freeze({
    BOY_LABEL: 'BOY',
    GIRL_LABEL: 'GIRL'
});

export default HP_Constants;